<template>
  <div class="w100">
    <UploadPdfHerramientaEstablecimiento
      ref="ModalUploadPdfHerramientaEstablecimiento"
      v-show="ModalVisible"
      @Cerrar="CloseModal()"
      @Refresh="CallFatherRefresh()"
    />
    <table>
      <thead>
        <tr>
          <th class="c1">Valor</th>
          <th>Fecha</th>
          <th class="pR c3">
            <font-awesome-icon
              v-on:click.stop="NewRecord()"
              v-show="AdminLogueado"
              icon="plus-circle"
              size="4x"
              :style="{ color: '#005625' }"
              class="IconoAgregar Centro"
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in RegistrosPag" :key="index">
          <td class="c1">
            <span @click="VerReportePDF(item)">
              <u>Ver Reporte</u>
            </span>
          </td>
          <td>{{ item.FechaAlta }}</td>
          <td class="c3">
            <font-awesome-icon
              v-show="item.Id > 0 && AdminLogueado && Online"
              v-on:click.stop="RemoveRecord(item.Id)"
              icon="trash-alt"
              size="4x"
              :style="{ color: '#934141' }"
              class="h100 IconoEliminar cP"
            />
            <font-awesome-icon
              v-show="item.Id <= 0"
              icon="spinner"
              size="4x"
              :style="{ color: '#000000' }"
              class="h100 IconoEliminar cP fa fa-spinner fa-spin"
            />
            <font-awesome-icon
              v-show="item.Id > 0 && AdminLogueado && Online"
              v-on:click.stop="DownloadPDF(item)"
              icon="download"
              size="4x"
              :style="{ color: '#444' }"
              class="h100 IconoEliminar cP"
            />
          </td>
        </tr>
      </tbody>
      <tbody></tbody>
    </table>

    <div class="SinRegistros" v-if="!this.records.length > 0">
      Aún no hay registros...
    </div>

    <SlidingPagination
      v-if="totalPages > 1"
      :slidingEndingSize="2"
      :slidingWindowSize="2"
      :current="currentPage"
      :total="totalPages"
      @page-change="PageChange"
    ></SlidingPagination>

    <div class="TituloPDF" ref="TituloPDF"></div>
    <pdf v-for="i in NumPagesPDF" :key="i" :page="i" :src="SrcPDF"></pdf>

    <br /><br />
  </div>
</template>

<script>
import pdf from "vue-pdf";
import ManejoDatos from "../Auxiliares/ManejoDatos.js";
import Clases from "../Auxiliares/Clases";
import SlidingPagination from "vue-sliding-pagination";
import UploadPdfHerramientaEstablecimiento from "./Utilidades/UploadPdfHerramientaEstablecimiento.vue";
export default {
  name: "",
  components: {
    SlidingPagination,
    UploadPdfHerramientaEstablecimiento,
    pdf,
  },
  props: {
    records: {
      type: Array,
      required: true,
    },
    idHerramientaEstablecimiento: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      SrcPDF: "",
      NumPagesPDF: 0,
      ModalVisible: false,
      //TODO: poner Paginado en un componente aparte
      currentPage: 1,
      totalPages: 0,
      ItemsPorPagina: 3,
      RegistrosPag: [],
    };
  },
  mounted() {
  },
  watch: {
    records: function (newVal, oldVal) {
      this.Refresh();
    },
  },
  methods: {
    Refresh() {
      this.totalPages = Math.ceil(this.records.length / this.ItemsPorPagina);
      var _Aux = [];
      for (let i = 0; i < this.records.length; i++) {
        if (i >= (this.currentPage - 1) * this.ItemsPorPagina) {
          if (i < this.currentPage * this.ItemsPorPagina) {
            _Aux.push(this.records[i]);
          }
        }
      }
      this.RegistrosPag = _Aux;
      if(this.RegistrosPag.length)
        this.VerReportePDF(this.RegistrosPag[0]);
    },
    CallFatherRefresh(){
      this.$emit("Refresh");
    },
    PageChange(selectedPage) {
      this.currentPage = selectedPage;
      this.Refresh();
    },
    NewRecord() {
      this.$refs.ModalUploadPdfHerramientaEstablecimiento.SetMe(this.idHerramientaEstablecimiento);
      this.VerModal();
    },
    VerModal() {
      this.ModalVisible = true;
    },
    CloseModal() {
      this.ModalVisible = false;
    },
    RemoveRecord(recordId) {
      var _This = this;
      this.$confirm({
        title: "ATENCIÓN",
        message: "Estás seguro de eliminar el registro?",
        button: {
          yes: "Si",
          no: "No",
        },
        callback: (confirm) => {
          if (confirm) {
            let idUsuario = Clases.GetUserLogged()._ID;
            fetch(
              `${this.urlPosts}/AgroIdeas/DeleteRegistroHerramienta/${idUsuario}/${recordId}`,
              { method: "DELETE" }
            )
              .then(function (response) {
                _This.$parent.$parent.Notificacion(
                  "Registro eliminado!",
                  "",
                  "success",
                  3
                );
                //_This.Refresh();
                _This.$emit("Refresh");
              })
              .catch(function (error) {
                _This.$parent.Notificacion("Error!", "", "error", 3);
                console.error(error);
              })
              .then(function () {
                //console.log("Ok");//LLega siempre que no haya catch
              });
          }
        },
      });
    },
    VerReportePDF(record) {
      this.SrcPDF = pdf.createLoadingTask(
        this.urlPosts + record.UrlDescarga
      );
      this.$refs.TituloPDF.innerHTML =
        "PDF cargado en fecha: " + record.FechaAlta;
      var _This = this;
      this.SrcPDF.promise
        .then((pdf) => {
          this.NumPagesPDF = pdf.numPages;
        })
        .catch((error) => {
          console.log(error);
          _This.$parent.$parent.Notificacion(
            "Error!",
            "Podrás acceder al PDF cuando recuperes el internet...",
            "error",
            3
          );
        });
    },
    DownloadPDF(record) {
      var urlDownload = `${this.urlPosts}/${record.UrlDescarga}`;

      var downloadName = `${Clases.GetUniqueName()}.pdf`;

      var _This = this;
      ManejoDatos.DescargarArchivo(urlDownload)
        .then((response) => {
          const type = response.headers["content-type"];
          const blob = new Blob([response.data], {
            type: type,
            encoding: "UTF-8",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = downloadName;
          link.click();
        })
        .catch((err) => {
          _This.$parent.Notificacion(
            "Parece que no tienes conexión",
            "Intenta más tarde!",
            "error",
            3
          );
        });
    },
  },
  computed: {
    AdminLogueado() {
      return this.$parent.$parent.Datos.AdminLogueado();
    },
    Online() {
      return this.$parent.$parent.Datos.AppOnline();
    },
    GetRecordsInPage() {
      this.totalPages = Math.ceil(this.records.length / this.ItemsPorPagina);
      return this.totalPages;
    },
  },
};
</script>
